export type ThemeMode = "light" | "dark" | "system";
export type ResolvedTheme = "light" | "dark";

export function getThemeMode(): ThemeMode {
  if (typeof window === "undefined") return "light";
  const stored = localStorage.getItem("radiece_theme") as ThemeMode | null;
  if (stored === "light" || stored === "dark" || stored === "system") {
    return stored;
  }
  // Default is light mode
  return "light";
}

export function getResolvedTheme(mode?: ThemeMode): ResolvedTheme {
  const currentMode = mode || getThemeMode();
  if (typeof window === "undefined") return "light";

  if (currentMode === "dark") return "dark";
  if (currentMode === "light") return "light";

  // System mode: track OS preference
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(mode: ThemeMode) {
  if (typeof window === "undefined") return;

  const resolved = getResolvedTheme(mode);

  if (resolved === "dark") {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }

  // Update theme-color meta tag for mobile status bar
  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  if (metaThemeColor) {
    metaThemeColor.setAttribute("content", resolved === "dark" ? "#090e17" : "#101c2a");
  }

  window.dispatchEvent(
    new CustomEvent("radiece_theme_change", {
      detail: { mode, resolved },
    }),
  );
}

export function setThemeMode(mode: ThemeMode) {
  if (typeof window === "undefined") return;
  localStorage.setItem("radiece_theme", mode);
  applyTheme(mode);
}

export function cycleTheme(): ThemeMode {
  const current = getThemeMode();
  let next: ThemeMode = "light";
  if (current === "light") next = "dark";
  else if (current === "dark") next = "system";
  else next = "light";

  setThemeMode(next);
  return next;
}
